<div class="py-4 px-0">
  <div class="container">
    <div class="row justify-content-between">
      <div class="col">
        <h1>{{ "faq.title" | translate }}</h1>
      </div>

      <div class="col-auto">
        <button type="button" class="btn btn-blue" (click)="isOpen = !isOpen">
          @if (isOpen) {
            {{ "faq.closeAll" | translate }}
          } @else {
            {{ "faq.openAll" | translate }}
          }

        </button>
      </div>
    </div>
    <!--/.row-->

    <div class="row">
      <div class="col">
        <h2>{{ "faq.general" | translate }}</h2>

        <accordion>
          @for (item of faqGeneral; track item) {
            <accordion-group [isOpen]="isOpen" #group1>
              <div accordion-heading class="row">
                <div class="col question">{{ item.question }}</div>
                <div class="col-auto">
                  <i class="fa" aria-hidden="true" [ngClass]="group1.isOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </div>
              </div>
              @for (paragraph of item.answer; track paragraph) {
                <p [innerHTML]="paragraph"></p>
              }
            </accordion-group>
          }
        </accordion>

        <h2>{{ "faq.material" | translate }}</h2>

        <accordion>
          @for (item of faqMaterial; track item) {
            <accordion-group [isOpen]="isOpen" #group2>
              <div accordion-heading class="row">
                <div class="col question">{{ item.question }}</div>
                <div class="col-auto">
                  <i class="fa" aria-hidden="true" [ngClass]="group2.isOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </div>
              </div>
              @for (paragraph of item.answer; track paragraph) {
                <p [innerHTML]="paragraph"></p>
              }
            </accordion-group>
          }
        </accordion>

        <h2>{{ "faq.organization" | translate }}</h2>

        <accordion>
          @for (item of faqOrganisation; track item) {
            <accordion-group [isOpen]="isOpen" #group3>
              <div accordion-heading class="row">
                <div class="col question">{{ item.question }}</div>
                <div class="col-auto">
                  <i class="fa" aria-hidden="true" [ngClass]="group3.isOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </div>
              </div>
              @for (paragraph of item.answer; track paragraph) {
                <p [innerHTML]="paragraph"></p>
              }
            </accordion-group>
          }
        </accordion>
      </div>
    </div>
    <!--/.row-->
  </div>
</div>
